/**
 * Core API
 * Core API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CampanaEstadosModel } from './campanaEstadosModel';
import { CampanaDTO } from './campanaDTO';


export interface CampanaPayloadDTO { 
    anio?: number;
    fechaInicio?: string;
    fechaFinalizacion?: string;
    descripcion?: string;
    estado?: CampanaEstadosModel;
    tipo?: CampanaPayloadDTO.TipoEnum;
    campanaAsociada?: CampanaDTO;
}
export namespace CampanaPayloadDTO {
    export type TipoEnum = 'DAE' | 'CVF';
    export const TipoEnum = {
        Dae: 'DAE' as TipoEnum,
        Cvf: 'CVF' as TipoEnum
    };
}


